/**
 * @generated SignedSource<<e9f4bc860ca3e7a8f076fc4d888acdd3>>
 * @relayHash ba4c4d88e134f3c8236a550bca0ab313
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID ba4c4d88e134f3c8236a550bca0ab313

import type { ConcreteRequest } from 'relay-runtime';
export type ApplyPendingIssueTypeSuggestionInput = {
  actorId: string;
  clientMutationId?: string | null | undefined;
  issueId: string;
  issueTypeId: string;
};
export type applyPendingIssueTypeSuggestionMutation$variables = {
  input: ApplyPendingIssueTypeSuggestionInput;
};
export type applyPendingIssueTypeSuggestionMutation$data = {
  readonly applyPendingIssueTypeSuggestion: {
    readonly clientMutationId: string | null | undefined;
  } | null | undefined;
};
export type applyPendingIssueTypeSuggestionMutation = {
  response: applyPendingIssueTypeSuggestionMutation$data;
  variables: applyPendingIssueTypeSuggestionMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "ApplyPendingIssueTypeSuggestionPayload",
    "kind": "LinkedField",
    "name": "applyPendingIssueTypeSuggestion",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "clientMutationId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "applyPendingIssueTypeSuggestionMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "applyPendingIssueTypeSuggestionMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "ba4c4d88e134f3c8236a550bca0ab313",
    "metadata": {},
    "name": "applyPendingIssueTypeSuggestionMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "4d3cec2739c60e473cce570c0d8871dc";

export default node;
